module.exports = __webpack_public_path__ + "media/images/case-studies/bonnie-beef-growers-1ef306948df3a949af6ac0a1237f5b58.png";